import React from 'react';
import LinkedInHeader from './LinkedInHeader';
import './LinkedInTheme.css';
import { Target, Cpu, Users, Globe, ShieldCheck, Zap } from 'lucide-react';
import { useTranslation, Trans } from 'react-i18next';

const About = () => {
  const { t } = useTranslation();

  return (
    <div className="li-centered-container">
            
            {/* Hero Section */}
            <div className="li-card" style={{ padding: '40px 24px', textAlign: 'center', background: 'linear-gradient(to bottom right, #ffffff, #f3f2ef)' }}>
                <h1 style={{ fontSize: '32px', fontWeight: '200', color: 'rgba(0,0,0,0.9)', marginBottom: '16px' }}>
                    {t('about.hero.title')}
                </h1>
                <p style={{ fontSize: '18px', color: 'rgba(0,0,0,0.6)', maxWidth: '700px', margin: '0 auto', lineHeight: '1.5' }}>
                    {t('about.hero.subtitle')}
                </p>
            </div>

            {/* Mission Section */}
            <div className="li-card" style={{ padding: '32px 24px' }}>
                <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap', alignItems: 'center' }}>
                    <div style={{ flex: 1, minWidth: '300px' }}>
                        <h2 style={{ fontSize: '24px', fontWeight: '600', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <Target color="#0a66c2" size={28} /> {t('about.mission.title')}
                        </h2>
                        <p style={{ fontSize: '16px', lineHeight: '1.6', color: 'rgba(0,0,0,0.75)', marginBottom: '16px' }}>
                            {t('about.mission.p1')}
                        </p>
                        <p style={{ fontSize: '16px', lineHeight: '1.6', color: 'rgba(0,0,0,0.75)' }}>
                            <Trans i18nKey="about.mission.p2">
                                Our mission is to democratize career growth by giving every professional an <strong>AI AI Twin</strong> that works for them 24/7. We aim to create a hiring ecosystem where skills and potential matter more than keywords on a PDF.
                            </Trans>
                        </p>
                    </div>
                    <div style={{ flex: 1, minWidth: '300px', display: 'flex', justifyContent: 'center' }}>
                         <img src="/Flat_illutrations/Dashboard.png" alt="POD+ Mission" style={{ width: '100%', maxWidth: '300px', borderRadius: '12px', boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px' }} />
                    </div>
                </div>
            </div>

            {/* How It Works Grid */}
            <div className="li-dashboard-grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))' }}>
                <div className="li-card" style={{ padding: '24px' }}>
                    <div style={{ marginBottom: '16px', color: '#0a66c2' }}><Cpu size={32} /></div>
                    <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px' }}>{t('about.howItWorks.digitalTwins.title')}</h3>
                    <p style={{ fontSize: '14px', lineHeight: '1.5', color: 'rgba(0,0,0,0.6)' }}>
                        {t('about.howItWorks.digitalTwins.text')}
                    </p>
                </div>
                <div className="li-card" style={{ padding: '24px' }}>
                    <div style={{ marginBottom: '16px', color: '#057642' }}><Globe size={32} /></div>
                    <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px' }}>{t('about.howItWorks.ans.title')}</h3>
                    <p style={{ fontSize: '14px', lineHeight: '1.5', color: 'rgba(0,0,0,0.6)' }}>
                        {t('about.howItWorks.ans.text')}
                    </p>
                </div>
                <div className="li-card" style={{ padding: '24px' }}>
                    <div style={{ marginBottom: '16px', color: '#7c3aed' }}><Zap size={32} /></div>
                    <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px' }}>{t('about.howItWorks.talentIntelligence.title')}</h3>
                    <p style={{ fontSize: '14px', lineHeight: '1.5', color: 'rgba(0,0,0,0.6)' }}>
                        {t('about.howItWorks.talentIntelligence.text')}
                    </p>
                </div>
            </div>

            {/* Core Values */}
            <div className="li-card" style={{ padding: '32px 24px' }}>
                <h2 style={{ fontSize: '24px', fontWeight: '600', marginBottom: '24px', textAlign: 'center' }}>{t('about.values.title')}</h2>
                <div style={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', gap: '24px' }}>
                    <div style={{ textAlign: 'center', maxWidth: '200px' }}>
                        <div style={{ margin: '0 auto 16px', width: '64px', height: '64px', background: '#eef3f8', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0a66c2' }}>
                            <Users size={32} />
                        </div>
                        <h4 style={{ fontSize: '16px', fontWeight: '600' }}>{t('about.values.humanCentric.title')}</h4>
                        <p style={{ fontSize: '13px', color: 'rgba(0,0,0,0.6)' }}>{t('about.values.humanCentric.text')}</p>
                    </div>
                    <div style={{ textAlign: 'center', maxWidth: '200px' }}>
                        <div style={{ margin: '0 auto 16px', width: '64px', height: '64px', background: '#eef3f8', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0a66c2' }}>
                            <ShieldCheck size={32} />
                        </div>
                        <h4 style={{ fontSize: '16px', fontWeight: '600' }}>{t('about.values.trustPrivacy.title')}</h4>
                        <p style={{ fontSize: '13px', color: 'rgba(0,0,0,0.6)' }}>{t('about.values.trustPrivacy.text')}</p>
                    </div>
                    <div style={{ textAlign: 'center', maxWidth: '200px' }}>
                        <div style={{ margin: '0 auto 16px', width: '64px', height: '64px', background: '#eef3f8', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0a66c2' }}>
                            <Target size={32} />
                        </div>
                        <h4 style={{ fontSize: '16px', fontWeight: '600' }}>{t('about.values.meritocracy.title')}</h4>
                        <p style={{ fontSize: '13px', color: 'rgba(0,0,0,0.6)' }}>{t('about.values.meritocracy.text')}</p>
                    </div>
                </div>
            </div>
    </div>
  );
};

export default About;
